import { useState } from 'react';
import { Modal } from './ui.tsx';
import { ActionDetailModal } from './ActionDetailModal.tsx';
import { EVENT_TYPE_LABEL, daysUntil, formatDateLong } from '../lib/format.ts';
import type { CalendarEvent } from '../../../shared/types.ts';

/** Visualização rápida de um evento do calendário — sem edição: o servidor
 * ainda não expõe PATCH/DELETE para calendar_events, só criação e a
 * sincronização de turnê. Se o evento tiver uma ação vinculada, abre o
 * modal de edição dela por cima — cruzamento real entre as duas telas. */
export function EventDetailModal({
  event,
  canEditAction,
  onClose,
}: {
  event: CalendarEvent;
  canEditAction: boolean;
  onClose: () => void;
}) {
  const [openAction, setOpenAction] = useState(false);
  const days = daysUntil(event.startDate);
  const relative = days === 0 ? 'Hoje' : days === 1 ? 'Amanhã' : days > 0 ? `Em ${days} dias` : `Há ${-days} dias`;

  return (
    <>
      <Modal title={event.title} onClose={onClose}>
        <div className="stack">
          <dl className="detail-grid">
            <div>
              <dt className="text-micro text-muted">Tipo</dt>
              <dd>
                <span className="badge badge-status-neutral">{EVENT_TYPE_LABEL[event.eventType]}</span>
              </dd>
            </div>

            <div>
              <dt className="text-micro text-muted">Data</dt>
              <dd>
                {formatDateLong(event.startDate)}
                {event.endDate && event.endDate !== event.startDate && (
                  <> até {formatDateLong(event.endDate)}</>
                )}
                <span className="text-micro text-muted"> · {relative}</span>
              </dd>
            </div>
          </dl>

          {event.description && <p className="text-body detail-description">{event.description}</p>}

          {event.linkedActionId && (
            <button
              type="button"
              className="btn btn-secondary btn-sm"
              onClick={() => setOpenAction(true)}
            >
              Ver ação vinculada
            </button>
          )}
        </div>
      </Modal>

      {openAction && event.linkedActionId && (
        <ActionDetailModal
          id={event.linkedActionId}
          canEdit={canEditAction}
          onClose={() => setOpenAction(false)}
          onChanged={() => {}}
        />
      )}
    </>
  );
}
